/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { formatCurrency, money, toast } from "../../../../utils/helpers";

// COMPONENTS
import Select, { createFilter } from "react-select";
import Modal from "../../../general/Modal";
import ItemFotos from "../../../Items/ItemFotos";

// Total de una línea devuelta, con las mismas operaciones y en el mismo orden
// que la factura (Facturacion/hooks/useProducto: costoReal + itbisReal). Con
// descuento, el total suele caer en medio centavo y la aritmética de punto
// flotante decide hacia dónde redondea; calcularlo de otra forma (precio ×
// cantidad − descuento) daba un centavo distinto a la factura.
export const totalLineaVenta = (precio, cantidad, descuento, porcentajeImpuesto, pierdeImpuestos) => {
	const tasa = parseFloat(porcentajeImpuesto) || 0;
	const porcentaje = parseFloat(descuento) || 0;

	// Sin descuento la factura guarda precio × cantidad tal cual.
	if (!porcentaje && !pierdeImpuestos) return precio * cantidad;

	const costo = parseFloat(precio) / (tasa + 1);
	const costoReal = (costo - (costo * porcentaje / 100)) * cantidad;

	return pierdeImpuestos ? costoReal : costoReal + costoReal * tasa;
};

// Cambiar el impuesto de una línea devuelta conserva su importe sin impuesto
// y recalcula el impuesto y el precio con la nueva tasa (decisión de negocio:
// p. ej. 100 + ITBIS 18 = 118 pasa a Exento como 100 + 0 = 100).
export const precioConImpuesto = (importeUnidad, porcentajeImpuesto) => {
	const tasa = parseFloat(porcentajeImpuesto) || 0;
	return {
		precio: importeUnidad * (1 + tasa),
		impuestoUnidad: importeUnidad * tasa,
	};
};

const ProductoFacturaNotaCredito = React.memo(
	({
		productos = [],
		impuestos = [],
		productoSelected = {},
		index,
		checkProductoRepetido,
		removeProductoSelected,
		isEdit,
		handleInputChange,
		isFactura,
		enableProducto,
        estaVencida,
	}) => {
		const [precioManual, setPrecioManual] = useState(0);
		const [showPrecioManual, setShowPrecioManual] = useState(true);
		const [showDelete, setShowDelete] = useState(false);
		const [showPINModal, setShowPINModal] = useState(false);
		const [showFotos, setShowFotos] = useState(false);
		const [pinSeguridad, setPinSeguridad] = useState(false);
		const [pierdeImpuestos, setPierdeImpuestos] = useState(isEdit ? productoSelected?.pierdeImpuesto : estaVencida);

		// CALCULOS FINALES
		const [total, setTotal] = useState(0);
		const [importe, setImporte] = useState(0);
		const [subtotal, setSubtotal] = useState(0);
		const [impuestoCalculado, setImpuestoCalculado] = useState(0);

		const productLabel = useCallback(
			(producto) => {
				if (isFactura) {
					return (
						<span className="row px-0 align-items-center">
							<span
								className="col-2 pr-1"
								style={{
									minWidth: "100px",
									wordBreak: "break-all",
								}}
							>
								{producto.producto?.referencia}
							</span>
							<span className="col-5 px-1">
								{producto.producto?.nombre}
							</span>
							<span
								className="col-1 px-1"
								style={{
									fontWeight: "bold",
									color: "#008aab",
								}}
							>
								{isNaN(parseFloat(producto.cantidad))
									? "∞"
									: parseFloat(producto.cantidad)}
							</span>
							<span
								className="col-2 pr-0"
								style={{
									fontWeight: "bold",
									color: "#008aab",
								}}
							>
								{formatCurrency(
									money(producto.precio_facturado) || 0,
									"$"
								)}
							</span>
						</span>
					);
				}

				return (
					<span className="row px-0 align-items-center">
						<span
							className="col-2 pr-1"
							style={{
								minWidth: "100px",
								wordBreak: "break-all",
							}}
						>
							{producto?.referencia}
						</span>
						<span className="col-5 px-1">{producto?.nombre}</span>
						<span
							className="col-1 px-1"
							style={{
								fontWeight: "bold",
								color: "#008aab",
							}}
						>
							{isNaN(parseFloat(producto.cantidad))
								? "∞"
								: parseFloat(producto.cantidad)}
						</span>
						<span
							className="col-2 pr-0"
							style={{
								fontWeight: "bold",
								color: "#008aab",
							}}
						>
							{formatCurrency(
								money(producto.precio || producto.costo) || 0,
								"$"
							)}
						</span>
					</span>
				);
			},
			[isFactura]
		);

		const onChangeProductoFactura = async (prod) => {
            const productoID = prod.value;
			productoSelected.productoID = productoID.value;

			if (checkProductoRepetido(productoID, index, productoSelected.id)) {
				removeProductoSelected(productoSelected.id);
				return;
			}

			const currProducto = productos.find(
				(producto) => producto.producto?.id === productoID
			);

            if (currProducto.cantidad <= 0) {
                toast('Esta factura no tiene este producto disponible para devolución', 'error');
                return;
            }

			const impuestoCalculado =
            currProducto.precio_facturado - (currProducto.precio_facturado / (1+currProducto.impuesto?.porcentaje));
			// Al elegir el producto la cantidad vuelve a 1; el efecto de cantidad no
			// se dispara si ya era 1, así que el descuento se aplica aquí.
			const descuentoCalculado =
				currProducto.precio_facturado * (currProducto.descuento / 100);

            const rimporte = currProducto.importe ||
                currProducto.precio_facturado /
                    (currProducto.impuesto.porcentaje + 1);

            const rtotal = totalLineaVenta(
                currProducto.precio_facturado,
                1,
                currProducto.descuento,
                currProducto.impuesto?.porcentaje,
                pierdeImpuestos
            );

			handleInputChange(
				null,
				{
					id: productoSelected.id,
					productoID: currProducto.producto?.id,
					nombre: (
						<>
							<span
								className="col-3 pl-1"
								style={{
									minWidth: "100px",
									wordBreak: "break-all !important",
								}}
							>
								{currProducto.producto?.referencia}
							</span>{" "}
							<span className="col-8">
								{currProducto.producto?.nombre}
							</span>
						</>
					),
					cantidad: 1,
					importe: rimporte,
					descuento: currProducto.descuento,
					existencia: currProducto.cantidad,
					unidad: currProducto.unidad ?? currProducto.producto?.unidad,
					impuesto: {
						value: currProducto.impuesto?.id,
						label: currProducto.impuesto?.nombre,
						porcentaje: currProducto.impuesto?.porcentaje,
						tipo: currProducto?.impuesto?.tipo,
					},
					impuestoCalculado: pierdeImpuestos ? 0 : impuestoCalculado,
					precioVenta: currProducto.precio_facturado,
					total: rtotal,
					descuentoCalculado,
					tipo: 'producto'
				},
				productoSelected.id,
				false
			);

			setPrecioManual(currProducto.precio_facturado);
			setTotal(rtotal);
			setImporte(rimporte);
			setImpuestoCalculado(impuestoCalculado);
		};

		const onChangeInput = (field, value) =>
			handleInputChange(field, value, productoSelected.id);

		const onChangeImpuesto = (opcion) => {
			if (!opcion) return;

			const importeUnidad = precioManual - impuestoCalculado;
			const { precio, impuestoUnidad } = precioConImpuesto(importeUnidad, opcion.porcentaje);
			const cantidad = productoSelected.cantidad || 1;
			const totalNuevo = totalLineaVenta(
				precio,
				cantidad,
				productoSelected.descuento,
				opcion.porcentaje,
				pierdeImpuestos
			);

			setPrecioManual(precio);
			setImpuestoCalculado(impuestoUnidad);
			setTotal(totalNuevo);

			onChangeInput("impuesto", {
				value: opcion.value,
				label: opcion.label,
				porcentaje: parseFloat(opcion.porcentaje) || 0,
				tipo: opcion.tipo,
			});
			onChangeInput("importe", importeUnidad);
			onChangeInput("precioVenta", precio);
			onChangeInput("total", totalNuevo);
			onChangeInput("impuestoCalculado", pierdeImpuestos ? 0 : impuestoUnidad * cantidad);
			onChangeInput(
				"descuentoCalculado",
				precio * cantidad * ((parseFloat(productoSelected.descuento) || 0) / 100)
			);
		};

		// Con 0 o vacío el efecto de cantidad no recalcula y la línea se
		// guardaba con el total de la cantidad anterior.
		const checkQuantityConstrains = () => {
			if (!productoSelected.productoID) return;
			if (parseFloat(productoSelected.cantidad) > 0) return;

			onChangeInput("cantidad", 1);
			toast("La cantidad a devolver debe ser mayor que 0", "error");
		};
		const calcularDescuento = () => {};

		const toggleDeleteModal = () => {
			setShowDelete((state) => !state);
		};

		const toggleFotosModal = () => {};
		const checkPINSeguridad = () => {};
		const togglePINModal = () => {};
		const productoITBIS = 0;
		const errors = {};


		useEffect(() => {
			if (!productoSelected.cantidad || !productoSelected.existencia)
				return;

			if (productoSelected.cantidad <= 0) {
				onChangeInput("cantidad", 1);
				toast("No incluir cantidades menores a 1", "error");
				return;
			} else if (
				(productoSelected.cantidad > productoSelected.existencia)
			) {
				onChangeInput("cantidad", productoSelected.existencia);
				toast(
					"Cantidad maxima permitida es: " +
						productoSelected.existencia,
					"error"
				);
				return;
			}

			// El descuento se calcula con la cantidad actual; usar el guardado en
			// productoSelected daría el de la cantidad anterior.
			const descuentoActual =
				precioManual *
				productoSelected.cantidad *
				(productoSelected.descuento / 100);
			const totalActual = totalLineaVenta(
				precioManual,
				productoSelected.cantidad,
				productoSelected.descuento,
				productoSelected.impuesto?.porcentaje,
				pierdeImpuestos
			);

			setTotal(totalActual);
			handleInputChange("total", totalActual, productoSelected.id);
			handleInputChange(
				"descuentoCalculado",
				descuentoActual,
				productoSelected.id
			);
			handleInputChange(
				"impuestoCalculado",
				pierdeImpuestos ? 0 : impuestoCalculado * productoSelected.cantidad,
				productoSelected.id
			);
		}, [productoSelected.cantidad, pierdeImpuestos]);

		useEffect(() => {
			if (!isEdit) return;
            const imp = productoSelected.precioVenta - (productoSelected.precioVenta / (1+productoSelected.impuesto?.porcentaje));
			setPrecioManual(productoSelected.precioVenta);

            const t = totalLineaVenta(
                productoSelected.precioVenta,
                productoSelected.cantidad,
                productoSelected.descuento,
                productoSelected.impuesto?.porcentaje,
                pierdeImpuestos
            );

			setTotal(t);

			handleInputChange(
				"total",
				t,
				productoSelected.id
			);
			// El efecto de cantidad corre antes que este, con precioManual todavía
			// en 0, y deja el descuento en 0: se recalcula con el precio de la línea.
			handleInputChange(
				"descuentoCalculado",
				productoSelected.precioVenta *
					productoSelected.cantidad *
					((parseFloat(productoSelected.descuento) || 0) / 100),
				productoSelected.id
			);
			handleInputChange(
				"impuestoCalculado",
				pierdeImpuestos ? 0 : imp * productoSelected.cantidad,
				productoSelected.id
			);
			setImpuestoCalculado(imp);
		}, []);

		return (
			<>
				<tr>
					<td colSpan={2}>
						<input
							type="hidden"
							name={`productos[${index}][id]`}
							value={isEdit ? productoSelected.id : "random1"}
						/>

						<Select
							type="text"
							filterOption={createFilter({
								ignoreAccents: false,
							})}
							// filterOption={filterOption}
							name={
								productoSelected.tipo === 'producto'
									? `productos[${index}][producto_id]`
									: `productos[${index}][item_id]`
							}
							placeholder={"Seleccione..."}
							value={
								productoSelected.id && {
									value: productoSelected.productoID,
									label: productoSelected.nombre,
								}
							}
							onChange={(e) => onChangeProductoFactura(e)}
							styles={{
								singleValue: (provided, state) => ({
									...provided,
									width: "100%",
									display: "flex",
								}),
								option: (provided, state) => ({
									...provided,
									backgroundColor: state.isSelected
										? "rgba(152, 204, 245,.3)"
										: "white",
									color: state.isSelected
										? "#008aab"
										: "#666666",
									fontWeight: state.isSelected
										? "600"
										: "normal",
								}),
							}}
							maxMenuHeight={200}
							options={
								productos &&
								productos.map((producto) => ({
									label: isFactura
										? `${producto.producto?.referencia} ${producto.producto?.nombre}`
										: `${producto?.referencia} ${producto?.nombre}`,
									value: isFactura
										? producto.producto?.id
										: producto.item_id,
									producto: producto,
								}))
							}
							formatOptionLabel={(option) =>
								option.producto
									? productLabel(option.producto)
									: option.label
							}
							isDisabled={!enableProducto}
						/>
					</td>
					<td>
						<input
							type="number"
							name={`productos[${index}][cantidad]`}
							placeholder="Cantidad"
							value={productoSelected.cantidad || undefined}
							step="1"
							min="1"
                            style={{maxWidth: "95px"}}
							onChange={(e) => {
								onChangeInput(
									"cantidad",
									parseFloat(e.target.value)
								);
							}}
							onBlur={() => checkQuantityConstrains()}
							className="form-control"
							readonly={!enableProducto}
						/>
					</td>
					<td>
                        {productoSelected.unidad}
					</td>
					<td>
                        {formatCurrency(
                            money((productoSelected.precio_venta || precioManual) - impuestoCalculado)
                        )}
						<input
							type="hidden"
							name={`productos[${index}][importe]`}
							className="form-control"
							value={(productoSelected.precio_venta || precioManual) - impuestoCalculado}
							readOnly
						/>
					</td>
					<td>
                        <>
                            {pierdeImpuestos ? (
                                <del>{productoSelected.impuesto?.label}</del>
                            ) : enableProducto && productoSelected.productoID ? (
                                <SelectorImpuesto
                                    impuestos={impuestos}
                                    impuesto={productoSelected.impuesto}
                                    onChange={onChangeImpuesto}
                                />
                            ) : (
                                <>{productoSelected.impuesto?.label}</>
                            )}

                            <input
                                type="hidden"
                                name={`productos[${index}][impuesto_id]`}
                                value={productoSelected.impuesto?.value}
                            />
                            <input
                                type="hidden"
                                name={`productos[${index}][impuestos]`}
                                value={
                                    impuestoCalculado * productoSelected.cantidad
                                }
                            />
                        </>
					</td>
					<td>
                        <>
                            {formatCurrency(
                                money(precioManual),
                                ""
                            )}
                            <input
                                type="hidden"
                                name={`productos[${index}][precio_facturado]`}
                                value={precioManual}
                            />
                        </>
					</td>
					<td>
                        {productoSelected.descuento}
                        <input
							type="hidden"
							name={`productos[${index}][descuento]`}
							className="form-control"
							value={productoSelected.descuento}
							readOnly
						/>
					</td>
                    {estaVencida && (
                        <td>
                            <label className='switch switch-3d switch-success mr-3'>
                                <input type='hidden' name='pierde_impuesto' value={pierdeImpuestos ? 'si' : 'no'} />
                                <input
                                    type='checkbox'
                                    className='switch-input'
                                    id='pierde_impuestos'
                                    name={`productos[${index}][pierde_impuesto]`}
                                    value='si'
                                    checked={pierdeImpuestos}
                                    onChange={() => setPierdeImpuestos(prev => !prev)}
                                />
                                <span className='switch-label' />
                                <span className='switch-handle' />
                            </label>
                        </td>
                    )}
					<td className="text-right">
						{!showPrecioManual ? (
							<input
								type="hidden"
								name={`productos[${index}][precio_facturado]`}
								value={
									productoSelected.costo +
										productoITBIS -
										calcularDescuento(
											productoSelected.costo,
											productoSelected.descuento,
											productoSelected.cantidad
										) || 0
								}
							/>
						) : (
							<input
								type="hidden"
								name={`productos[${index}][precio_facturado]`}
								value={precioManual}
							/>
						)}

						<input
							type="hidden"
							name={`productos[${index}][total]`}
							value={total}
						/>
						{formatCurrency(money(total))}
					</td>
					<td className="text-center">
						{productoSelected.fotos?.length > 0 && (
							<button
								type="button"
								title="Ver Fotos"
								onClick={() => toggleFotosModal()}
								className="producto"
							>
								<i className="fas fa-eye"></i>
							</button>
						)}
					</td>
					<td className="text-right">
						<button
							type="button"
							className="btn btn-danger"
							onClick={() =>
								isEdit
									? toggleDeleteModal()
									: removeProductoSelected(
											productoSelected.id
									  )
							}
						>
							<i className="fas fa-trash"></i>
						</button>
					</td>
				</tr>
				{errors[`productos.${index}.total`] && (
					<small
						className="help-blockParams form-Text d-block"
						style={{ whiteSpace: "nowrap" }}
					>
						{errors[`productos.${index}.total`][0]}
					</small>
				)}
				{productoSelected?.fotos && (
					<Modal
						show={showFotos}
						blank={true}
						toggle={() => setShowFotos((state) => !state)}
					>
						<ItemFotos
							toggle={() => setShowFotos((state) => !state)}
							fotos={productoSelected.fotos}
						/>
					</Modal>
				)}
				<Modal
					title="Borrar Producto"
					show={showDelete}
					callback={() => removeProductoSelected(productoSelected.id)}
					acceptText="Borrar"
					toggle={toggleDeleteModal}
				>
					¿Estás seguro de que deseas borrar este producto?
				</Modal>
				{/* <---PIN DE SEGURIDAD MODAL--- */}
				<Modal
					title="PIN de seguridad"
					show={showPINModal}
					callback={() => checkPINSeguridad()}
					acceptText="Aceptar"
					toggle={() => togglePINModal()}
					size="419px"
				>
					<div className="form-group">
						<label>PIN de seguridad</label>
						<input
							type="password"
							className="form-control"
							id="PIN"
							name="pin_seguridad"
							value={pinSeguridad}
							onChange={(e) => setPinSeguridad(e.target.value)}
						/>
						<p
							className="font-weight-bold"
							style={{
								color: "gray",
								fontStyle: "italic",
								lineHeight: "13px",
								fontSize: "0.7rem",
							}}
						>
							Para continuar ingrese PIN de seguridad
						</p>
					</div>
				</Modal>
			</>
		);
	}
);

// Selector del impuesto de una línea de nota de crédito (ventas y compras).
export const SelectorImpuesto = ({ impuestos, impuesto, onChange }) => (
	<Select
		placeholder="Impuesto"
		options={impuestos}
		value={impuesto?.value ? impuestos.find((i) => i.value === impuesto.value) || impuesto : null}
		onChange={onChange}
		menuPortalTarget={document.body}
		styles={{
			menuPortal: (base) => ({ ...base, zIndex: 9999 }),
			container: (base) => ({ ...base, minWidth: "150px" }),
		}}
	/>
);

export default ProductoFacturaNotaCredito;
